import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';
import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class ShipmentCreationTemplate extends Model {
  @Expose()
  id: number;

  @Expose()
  type: ShipmentCreationTemplateTypes;

  @Expose()
  name: string;

  @Expose()
  logo?: string;

  @Expose()
  object?: string;

  @Expose()
  objectType?: string;

  @Expose()
  isDefault?: boolean;

  @Expose()
  createdAt?: number;

  @Expose()
  updatedAt?: number;
}
